import {
  SET_ACTIVE_FILTER,
  SET_VIEW,
  SET_SORT,
  SET_RESULTS,
  SET_FILTER_RANGE,
  SET_FILTER_CHOICE,
  TOGGLE_FILTER_MONTHLY,
  SET_GENRE,
  LOAD_MORE,
  SET_FILTER_VALUES,
  RESET_FILTER,
  CLEAR_FILTERS,
  OPEN_FILTERS_MODAL,
  CLOSE_FILTERS_MODAL,
  APPLY_FILTERS,
  SET_FEATURE_CARDS,
} from './types';

export const setActiveFilter = payload => ({
  type: SET_ACTIVE_FILTER,
  payload,
});

export const setView = payload => ({
  type: SET_VIEW,
  payload,
});

export const setSort = payload => ({
  type: SET_SORT,
  payload,
});

export const setResults = payload => ({
  type: SET_RESULTS,
  payload,
});

export const loadMore = payload => ({
  type: LOAD_MORE,
  payload,
});

export const setFilterRange = payload => ({
  type: SET_FILTER_RANGE,
  payload,
});

export const setFilterChoice = payload => ({
  type: SET_FILTER_CHOICE,
  payload,
});

export const toggleFilterMonthly = payload => ({
  type: TOGGLE_FILTER_MONTHLY,
  payload,
});

export const setGenre = payload => ({
  type: SET_GENRE,
  payload,
});

export const setFilterValues = payload => ({
  type: SET_FILTER_VALUES,
  payload,
});

export const resetFilter = payload => ({
  type: RESET_FILTER,
  payload,
});

export const clearFilters = () => ({
  type: CLEAR_FILTERS,
});

export const openFiltersModal = () => ({
  type: OPEN_FILTERS_MODAL,
});

export const closeFiltersModal = () => ({
  type: CLOSE_FILTERS_MODAL,
});

export const applyFilters = () => ({
  type: APPLY_FILTERS,
});

export const setFeatureCards = payload => ({
  type: SET_FEATURE_CARDS,
  payload,
});
